"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'settings.credit.description': 'Configurar tasas de conversión de créditos para servicios de IA',
    'settings.credit.failedToLoad': 'Error al cargar la configuración de créditos',
    'settings.credit.savedSuccessfully': 'Configuración de créditos guardada exitosamente',
    'settings.credit.failedToSave': 'Error al guardar la configuración de créditos',
    'settings.credit.save': 'Guardar Configuración de Créditos',
    'settings.credit.reload': 'Recargar',
    'settings.credit.credits': 'créditos',
    'settings.credit.conversion.title': 'Conversión de Moneda',
    'settings.credit.conversion.dollarToCreditRate': 'Créditos por USD',
    'settings.credit.conversion.dollarToCreditRate.help': 'Cuántos créditos equivalen a 1 USD. Esto afecta los precios de todas las operaciones de IA.',
    'settings.credit.preview.title': 'Vista Previa de Conversión',
    'settings.credit.warning.title': 'Aviso Importante',
    'settings.credit.warning.description': 'Los cambios en las tasas de crédito afectarán todas las futuras operaciones de IA. Los créditos existentes de los usuarios no se verán afectados.',
};
